import Input from "../../components/Input";
import Button from "../../components/Buttons/button";
import { Key01 } from "@untitledui/icons/Key01";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/modal.slice";

import * as yup from "yup";
import { Formik } from "formik";
import { changePassword_req } from "../../api/profiles.api";
import Alert from "../../components/Alert";
import { changePasswordProfile_Req } from "../../api/user.api";

const ChangePasswordModal = () => {
  const dispatch = useDispatch();
  const closePopup = () => {
    dispatch(closeModal({}));
  };
  const signUpScheme = yup.object().shape({
    current_password: yup.string().required("Current Password is required"),
    password: yup
      .string()
      .min(6, "Password must be at least 6 characters")
      .matches(/[A-Z]/, "Password must have at least one uppercase letter")
      .matches(/[a-z]/, "Password must have at least one lowercase letter")
      .matches(/\d/, "Password must have at least one digit")
      .matches(
        /[@$!%*?&_.]/,
        "Password must have at least one special symbol (@, $, !, %, *, ?, &, _, .)"
      )
      .required("Password is required"),
    password_confirmation: yup
      .string()
      .oneOf([yup.ref("password"), undefined], "Passwords must match")
      .required("Confirm password is required"),
  });

  const changePassword = async (values) => {
    try {
      const response = await changePasswordProfile_Req(values);
      closePopup();
    } catch (e) {
      console.log("e", e);
    }
  };
  return (
    <>
      <div className="modal-header text-center">
        <div className="icon purple">
          <Key01 />
        </div>
        <h4 className="mb-8">Change Password</h4>
        <p className="text-color-grey">
          Choose a new password — make sure it’s secure and easy to remember.
        </p>
      </div>
      <div className="modal-body">
        <Formik
          initialValues={{
            current_password: "",
            password: "",
            password_confirmation: "",
          }}
          validateOnMount={true}
          onSubmit={(values) => changePassword(values)}
          validationSchema={signUpScheme}
        >
          {({ handleChange, handleSubmit, values, touched, errors }) => {
            return (
              <>
                <Input
                  id={"current-password"}
                  label={"Current Password"}
                  placeholder={"Enter your current password"}
                  onChange={handleChange}
                  name={"current_password"}
                  type={"password"}
                  className="mb-24"
                  errorMessage={
                    touched?.current_password &&
                    errors?.current_password &&
                    errors.current_password
                  }
                />
                <Input
                  id={"new-password"}
                  label={"New Password"}
                  placeholder={"Enter your new password"}
                  name={"password"}
                  onChange={handleChange}
                  type={"password"}
                  className="mb-24"
                  errorMessage={
                    touched?.password && errors?.password && errors.password
                  }
                />
                <Input
                  id={"password_confirmation"}
                  label={"Repeat Password"}
                  placeholder={"Confirm your password"}
                  name={"password_confirmation"}
                  type={"password"}
                  className="mb-16"
                  onChange={handleChange}
                  errorMessage={
                    touched?.password_confirmation &&
                    errors?.password_confirmation &&
                    errors.password_confirmation
                  }
                />
                <Button
                  text={"Change Password"}
                  className={"mb-12"}
                  fullWidth={true}
                  onClick={handleSubmit}
                />
                <Button
                  text={"Cancel"}
                  type={"outline"}
                  fullWidth={true}
                  onClick={closePopup}
                />
              </>
            );
          }}
        </Formik>
      </div>
    </>
  );
};

export default ChangePasswordModal;
